import "./App.css";

import { useState, useEffect, Fragment } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import MainPage from "./pages/MainPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

const App = () => {
  const { REACT_APP_URL } = process.env;
  // states
  const [configs, setConfigs] = useState({});

  useEffect(() => {
    const getConfigs = async () => {
      try {
        const res = await fetch(`${REACT_APP_URL}/api/getConfig`);
        const data = await res?.json();
        setConfigs(data);
      } catch (err) {
        console.log(err);
      }
    };
    getConfigs();
  }, []);

  return (
    <div className="App">
      <Header configs={configs} />
      <Routes>
        <Route exact path="/" element={<MainPage />} />
      </Routes>
      <Footer configs={configs} />
    </div>
  );
};

export default App;
